// Common
import { ReactElement, useCallback } from 'react'

// Styles
import { withStyles, makeStyles, Theme, createStyles } from '@material-ui/core/styles'

// Components
import Slider from '@material-ui/core/Slider'
import Typography from './typography'
import useMobile from 'components/hooks/useMobile'

interface IProps {
	min: number,
	max: number,
	variant: string,
	defaultValue: number,
	value?: number,
	onChange?: (event: unknown, value: number | number[]) => void,
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
		},
		margin: {
			height: theme.spacing(3),
		},
		text: {
			margin: 5,
		},
	}),
)

const BoxShadow =
	'0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)'

const CustomSlider = withStyles({
	root: {
		color: '#8A54E8',
		height: 8,
		padding: '15px 0',
	},
	thumb: {
		height: 18,
		width: 18,
		backgroundColor: '#8A54E8',
		boxShadow: BoxShadow,
		marginTop: -5,
		marginLeft: -5,
		'&:focus, &:hover, &$active': {
			boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
			'@media (hover: none)': {
				boxShadow: BoxShadow,
			},
		},
	},
	active: {},
	valueLabel: {
		left: 'calc(-50% + 3px)',
		top: -22,
		'& *': {
			background: 'transparent',
			color: '#8A54E8',
			height: '23px',
    	padding: '4px',
		},
		border: '1px solid #8A54E8',
		borderRadius: '2px',
	},
	track: {
		height: 8,
		borderRadius: '50px',
	},
	rail: {
		height: 8,
		opacity: 0.5,
		backgroundColor: '#c4c4c4',
		borderRadius: '50px',
	},
})(Slider)

export default function CustomizedSlider(props: IProps): ReactElement {
	const { min, max, variant, defaultValue, value, onChange } = props
	const classes = useStyles()
	const changeVariant = useCallback(() => {
		switch(variant){
		case 'area':
			return [`< ${min}m²`, `> ${max}m²`]
		case 'age':
			return [`before ${min}`, `${max}`]
		case 'quantity':
			return [`${min}`, `> ${max}`]
		default:
			return ['', '']
		}
	}, [min, max, variant])

	const mobile = useMobile()
	return (
		<div className={classes.root} style={mobile ? {width: '150px', flexDirection: 'column'} : {width: '350px'}}>
			<Typography className={classes.text} style={variant !== 'quantity' ? {width: '100px'} : {width: '35px'}}>
				{changeVariant()[0]}
			</Typography>
			<div className={classes.margin} />
			<CustomSlider
				aria-label="slider"
				defaultValue={defaultValue}
				valueLabelDisplay="on"
				min={min}
				max={max}
				value={value}
				onChange={onChange}
			/>
			<div className={classes.margin} />
			<Typography className={classes.text} style={{width: '100px'}} >
				{changeVariant()[1]}
			</Typography>
		</div>
	)
}
